<template>
  <v-text-field
    type="text"
    :label="label || $t('button.search')"
    append-icon="mdi-magnify"
    single-line
    hide-details
    style="margin: 1.5vh"
    v-bind="{...$attrs, ...$props}"
    v-on="$listeners"
  />
</template>
<script>

export default {
  name: 'SearchField',

  props: {
    label: String
  }
}
</script>
